import { z } from 'zod';
/**
 * 2048-to-Target — slide & merge.
 *
 * The classic 2048 slide: push all tiles one direction, equal neighbours merge
 * into their sum, and a new tile appears. But instead of an open-ended score
 * chase, you win the instant any tile reaches a fixed TARGET (e.g. 64 or 128).
 * That gives it a clean solved state — the "locked once achieved" property the
 * race format needs — rather than a score you grind forever.
 *
 * The board and every spawned tile are seeded, so both players get an identical
 * sequence of tiles and it is a test of planning, not luck.
 */
export const TWO048_SIZE = 4;
export const TWO048_DIRECTIONS = ['up', 'down', 'left', 'right'];
export const Two048MoveEvent = z.object({
    type: z.literal('move'),
    dir: z.enum(TWO048_DIRECTIONS),
});
export const Two048Event = z.discriminatedUnion('type', [Two048MoveEvent]);
//# sourceMappingURL=two048.js.map